import { FolderOpenIcon } from "@heroicons/react/20/solid";
import { projects } from "./../../data/projects";

import React, { useEffect, useState } from "react";
import { ProjectCard } from "./ProjectCard/ProjectCard";
import { teamProjects } from "../../data/teamprojects";

export type ProjectType = {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  isFlipped: boolean;
};

type Props = {
  theme: boolean;
};
export default function Projects({ theme }: Props) {
  const [changedProjects, setChangedProjects] = useState<ProjectType[]>([]);
  const projectsArray = ["Personal Projects", "Team Projects"];
  const [filter, setFilter] = useState<string>("PersonalProjects");

  const handleFlipped = (id: number) => {
    setChangedProjects(
      changedProjects.map((p) =>
        p.id === id
          ? { ...p, isFlipped: !p.isFlipped }
          : { ...p, isFlipped: false }
      )
    );
  };
  const handleFilter = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    if (e.currentTarget.value) {
      setFilter(e.currentTarget.value);
    }
  };
  useEffect(() => {
    if (filter.includes("Personal")) {
      setChangedProjects(projects);
    } else {
      setChangedProjects(teamProjects);
    }
  }, [filter]);

  return (
    <>
      <section
        id="projects"
        className={`text-gray-400 bg-white dark:bg-gray-900 projects-section-inset body-font bg-layout ${
          !theme ? "blue__gradient" : ""
        }`}
      >
        <div className="py-10 text-center">
          <div className="flex flex-col w-full mb-20">
            <FolderOpenIcon
              className={`mx-auto inline-block w-10 mb-4 text-5xl text-green-500 ${
                theme ? "text-green-500" : "text-lightgreen"
              }`}
            />
            <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-black dark:text-white">
              Apps and pages I've Built
            </h1>
            <p className="lg:w-2/3 mx-auto mb-8 leading-relaxed text-gray-800 dark:text-gray-400">
              The list includes part of the projects that I've worked on in the
              last year.
            </p>
            <div className="w-full md:w-2/6 mx-auto">
              <select
                className="bg-white-100 dark:bg-gray-800 rounded border border-gray-700 hover:border-indigo-500 focus:ring-2 hover:ring-indigo-900 dark:text-white text-center text-gray-900 outline-none py-2 px-6 leading-8 transition-colors duration-200 ease-in-out"
                onChange={handleFilter}
                name="projects"
                id="projects"
              >
                {projectsArray.map((p,index) => (
                  <option className="p-3 text-left" key={index} value={p}>{p}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="xl:px-32 lg:px-0 md:px-10 lg:w-3/4 w-11/12 mx-auto">
            <div className="flex flex-col md:flex-row md:flex-wrap m-4 justify-between ">
              {changedProjects.length > 0 &&
                changedProjects.map((project: ProjectType) => (
                  <ProjectCard
                    key={project.id}
                    handleFlipped={handleFlipped}
                    project={project}
                  />
                ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
